import { render, staticRenderFns } from "./IndicatorView.vue?vue&type=template&id=2c07714f&"
import script from "./IndicatorView.vue?vue&type=script&lang=js&"
export * from "./IndicatorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports